// Unpublished Work © 2024 Deere & Company.
import { GridSortDirection } from "@mui/x-data-grid-pro";
import { createContext, ReactElement, useState } from "react";
import { FilterWithInfo } from "../invoicesGrid/types";

export type InvoicesListContextProps = {
  setInvoicesListContext: (value: InvoicesListContextState) => void;
  getInvoicesListContext: () => InvoicesListContextState | undefined;
};

export type InvoicesListContextState = {
  filters: FilterWithInfo;
  sortField?: string;
  sortDir?: GridSortDirection;
  pageNumber: number;
  pageSize: number;
};

export const InvoicesListContext = createContext<InvoicesListContextProps>({
  getInvoicesListContext: () => undefined,
  setInvoicesListContext: () => {},
});

export const InvoicesListProvider = ({
  children,
}: {
  children: ReactElement;
}) => {
  const [invoicesListState, setInvoicesListState] = useState<
    InvoicesListContextState | undefined
  >(undefined);

  const setInvoicesListContext = (value: InvoicesListContextState) => {
    setInvoicesListState(value);
  };

  const getInvoicesListContext = (): InvoicesListContextState | undefined =>
    invoicesListState;

  return (
    <InvoicesListContext.Provider
      value={{
        setInvoicesListContext,
        getInvoicesListContext,
      }}
    >
      {children}
    </InvoicesListContext.Provider>
  );
};
